import { Button, ButtonGroup, Icon, Link, SidePanel, Text } from '@nike/eds'
import { OrderSearchInputs } from './OrderSearchInputs'
import { ChangeEvent, useState } from 'react'
import {
  mapObjectValues,
  textInputToSearchParams,
  useQueryParameters,
  QueryParams,
} from '../../../common/hooks/QueryParamsHook'
import Chips from '../../../common/components/chips/Chips'
import { Divider } from '@mui/material'
import { OrdersTable } from './OrdersTable'
import { SinglelineSearchInput } from '../../../common/components/multiline-input/SinglelineSearchInput'

export function OrdersSearch() {
  const [expandFilterForm, setExpandFilterForm] = useState(false)
  const [{ searchParameters }, setQueryParameters] = useQueryParameters()
  const [inputState, setInputState] = useState<Record<string, string>>(
    mapObjectValues(searchParameters, (searchParamValue) => searchParamValue.join(','))
  )
  const [sidepanelInitState, setSidepanelInitState] = useState<Record<string, string>>( //this is the state at the time the sidepanel is opened
    mapObjectValues(searchParameters, (searchParamValue) => searchParamValue.join(','))
  )

  function _setQueryParameters(qp: QueryParams) {
    setQueryParameters(qp)
  }

  function updateTextAreaSearchParameter(event: ChangeEvent<HTMLTextAreaElement>) {
    const newInputState = {
      ...inputState,
      [event.target.name]: event.target.value,
    }
    setInputState(newInputState)
    const searchParameters = {
      ...textInputToSearchParams(newInputState),
      search: [newInputState.search],
    }
    _setQueryParameters({
      searchParameters,
      paging: { from: 0 },
    })
  }

  function clearTextAreasSearchParameters() {
    setInputState({})
    _setQueryParameters({ searchParameters: {}, paging: { from: 0 } })
  }

  function submitForm() {
    _setQueryParameters({
      searchParameters: textInputToSearchParams(inputState),
      paging: { from: 0 },
    })
    setExpandFilterForm(false)
  }

  function dismissSidePanel() {
    setExpandFilterForm(false)
    setInputState(sidepanelInitState)
    _setQueryParameters({
      searchParameters: textInputToSearchParams(sidepanelInitState),
      paging: { from: 0 },
    })
  }

  return (
    <>
      <SidePanel
        hasScrim={false}
        onDismiss={dismissSidePanel}
        isOpen={expandFilterForm}
        headerSlot={
          <>
            <Text font="title-2" as="h2">
              Filter
            </Text>
            <span className="eds-type--body-2">
              <Link as="button" variant="secondary" onClick={clearTextAreasSearchParameters}>
                Clear All
              </Link>
            </span>
          </>
        }
        footerSlot={
          <ButtonGroup>
            <Button variant="primary" size="small" type="submit" onClick={submitForm}>
              Apply
            </Button>
          </ButtonGroup>
        }
      >
        <OrderSearchInputs inputState={inputState} setInputState={setInputState} />
      </SidePanel>

      <div className="column-layout--row-gap-8">
        <div
          className="flex-row flex-nowrap content-space-between justify-items-start"
          style={{ padding: 'var(--eds-space-16) 0 0 var(--eds-space-16)' }}
        >
          <div
            style={{
              width: '90%',
            }}
          >
            <Chips
              inputState={inputState}
              setInputState={setInputState}
              setQueryParameters={setQueryParameters}
              clearInputState={clearTextAreasSearchParameters}
            />
          </div>

          <div className="flex-shrink-0">
            <div className="flex-row" style={{ gap: 'var(--eds-space-8)' }}>
              <SinglelineSearchInput
                name="search"
                label=""
                value={inputState.search}
                onChange={updateTextAreaSearchParameter}
                placeholder="Delivery Note, Order, Ship To Number"
                beforeSlot={<Icon name="Search" />}
                width={350}
              />

              <Button
                style={{
                  marginTop: 'var(--eds-space-8)',
                  padding: 'var(--eds-space-8) var(--eds-space-16)',
                }}
                onClick={() => {
                  setExpandFilterForm(true)
                  setSidepanelInitState(inputState)
                }}
                beforeSlot={<Icon name="Filter" />}
              >
                Filters
              </Button>
            </div>
          </div>
        </div>

        <Divider
          style={{
            width: '99%',
            margin: 'auto',
            borderBottomWidth: 2,
          }}
        />
        <OrdersTable />
      </div>
    </>
  )
}
